import { useState, useEffect } from 'react'
import { ICycleData } from '../types/cycleSession'
import { planningApi } from '../services/api'

interface UseSessionContentResult {
  data: ICycleData | null
  loading: boolean
  error: string | null
  refetch: () => void
}

/**
 * Hook para buscar e gerenciar dados do conteúdo de uma sessão de estudo
 * @param courseId - ID do curso
 */
export const useSessionContent = (
  courseId: string | null,
  moduleId: string | null
): UseSessionContentResult => {
  const [data, setData] = useState<null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const fetchContent = async () => {
    if (!courseId || !moduleId) {
      setData(null)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const response = await planningApi.getProgressInfoByModuleId(courseId, moduleId)
      setData(response)
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao carregar conteúdo da sessão')
      console.error('Error fetching session content:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchContent()
  }, [courseId, moduleId])

  return {
    data,
    loading,
    error,
    refetch: fetchContent,
  }
}
